import { Button } from '../../../base/Button/Button';
import { LocationAutocompleteInput } from '../../../base/AutocompleteInput/LocationAutocompleteInput';
import type { PlaceOption } from '../../../../data/places';
import styles from './StopSearchForm.module.css';

interface StopSearchFormProps {
  value: string;
  options: PlaceOption[];
  onValueChange: (value: string) => void;
  onSubmit: (event?: SubmitEvent, selection?: PlaceOption) => void;
  onUseCurrentLocation?: () => void | Promise<void>;
  placeholder?: string;
  submitLabel?: string;
  autoSubmitOnSelect?: boolean;
  showSubmitButton?: boolean;
  minimal?: boolean;
}

export function StopSearchForm({
  value,
  options,
  onValueChange,
  onSubmit,
  onUseCurrentLocation,
  placeholder = 'Search for a location...',
  submitLabel = 'Explore nearby stops',
  autoSubmitOnSelect = false,
  showSubmitButton = true,
  minimal = false,
}: StopSearchFormProps) {
  return (
    <form
      className={styles.form}
      data-minimal={minimal || undefined}
      onSubmit={(event) => onSubmit(event as SubmitEvent)}
    >
      <LocationAutocompleteInput
        label="Enter a stop name, location or postcode"
        placeholder={placeholder}
        value={value}
        onValueChange={onValueChange}
        onSelectOption={(option) => {
          if (autoSubmitOnSelect) {
            onSubmit(undefined, option);
          }
        }}
        currentLocationAction={
          onUseCurrentLocation
            ? {
                onSelect: onUseCurrentLocation,
              }
            : undefined
        }
        options={options}
      />
      {showSubmitButton && <Button type="submit">{submitLabel}</Button>}
    </form>
  );
}
